<script lang="ts">
  import { storeHeroMenu } from "$lib/js/stores";
  import { t } from 'svelte-i18n-lingui';

  interface Props {
    type?: string; // '' | 'home'
  }

  let { type = '' }: Props = $props();

  function openMenu() {
    $storeHeroMenu = 'shops';
  }

  let innerWidth = $state(0);
  
</script>


<svelte:window bind:innerWidth />

{#if innerWidth > 1024}
  <button class="shops-btn {type}" onmouseenter={() => openMenu()}>
    <span class="icon icon-shop"></span>
    {$t`Shops`}
  </button>
{:else if innerWidth > 768}
  <button class="shops-btn" onclick={() => openMenu()}>
    <span class="icon icon-shop"></span>
    {$t`Shops`}
  </button>
{/if}


<style lang="scss">
  .shops-btn {
    transition: all linear 0.125s;
    font-size: 16px;
    font-weight: 700;
    padding-right: 25px;
    margin-left: 5px;

    @media (min-width: 769px) {
      margin-top: 4px;
      margin-right: 10px;
      border-right: 1px solid black;
    }

    &.home {
      margin-left: 15px;
    }

    .icon {
      display: inline-block;
      transform: scaleX(-1);
      font-size: 13px;
      margin-right: 8px;
    }
  }
</style>